import React from "react";
import {
  Box,
  Paper,
  Stack,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Chip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { STATUS_OPTIONS, ENABLED_OPTIONS, TYPE_OPTIONS } from "./constants";

const FilterBar = ({
  q,
  onQChange,
  status,
  onStatusChange,
  type,
  onTypeChange,
  enabled,
  onEnabledChange,
  onClearAll,
}) => {
  const activeChips = [
    q?.trim()
      ? {
          key: "q",
          label: `Search: “${q.trim()}”`,
          onDelete: () => onQChange(""),
        }
      : null,
    status
      ? {
          key: "status",
          label: `Status: ${status}`,
          onDelete: () => onStatusChange(""),
        }
      : null,
    type
      ? {
          key: "type",
          label: `Type: ${type}`,
          onDelete: () => onTypeChange(""),
        }
      : null,
    enabled
      ? {
          key: "enabled",
          label: `Enabled: ${enabled === "true" ? "true" : "false"}`,
          onDelete: () => onEnabledChange(""),
        }
      : null,
  ].filter(Boolean);

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        alignItems={{ xs: "stretch", md: "center" }}
        useFlexGap
        flexWrap="wrap">
        <TextField
          value={q}
          onChange={(e) => onQChange(e.target.value)}
          placeholder="Search name / description / coupon"
          size="small"
          sx={{ minWidth: 320, flex: 1 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel>Status</InputLabel>
          <Select
            label="Status"
            value={status}
            onChange={(e) => onStatusChange(e.target.value)}>
            {STATUS_OPTIONS.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label || <em>All statuses</em>}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 220 }}>
          <InputLabel>Type</InputLabel>
          <Select
            label="Type"
            value={type}
            onChange={(e) => onTypeChange(e.target.value)}>
            {TYPE_OPTIONS.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label || <em>All types</em>}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel>Enabled</InputLabel>
          <Select
            label="Enabled"
            value={enabled}
            onChange={(e) => onEnabledChange(e.target.value)}>
            {ENABLED_OPTIONS.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label || <em>All</em>}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>

      {activeChips.length > 0 && (
        <Box
          sx={{
            mt: 1,
            display: "flex",
            justifyContent: { xs: "flex-start", md: "flex-end" },
            width: "100%",
          }}>
          <Stack
            direction="row"
            spacing={1}
            useFlexGap
            flexWrap="wrap"
            justifyContent="flex-end">
            {activeChips.map((c) => (
              <Chip
                key={c.key}
                label={c.label}
                onDelete={c.onDelete}
                size="small"
                variant="outlined"
              />
            ))}
            <Chip
              label="Clear all"
              onClick={onClearAll}
              onDelete={onClearAll}
              size="small"
              color="error"
              variant="outlined"
            />
          </Stack>
        </Box>
      )}
    </Paper>
  );
};

export default FilterBar;
